module.exports = __webpack_public_path__ + "static/media/001 color panel.bdd67d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/001 color panel.png
// module id = 497
// module chunks = 0